<template>
  <div class="scrollable only-y queue-reports-dashboard">
    <el-dialog
      class="queue-reports-modal"
      width="440px"
      :visible="modalVisible"
      :before-close="handleCloseModal"
      :close-on-click-modal="false"
    >
      <h2 class="form-section-header">Filter Settings</h2>

      <h3 class="black-text mb-5">Select Date Range</h3>
      <el-date-picker
        class="mb-10"
        style="margin-left: auto"
        v-model="historyDateRange"
        type="datetimerange"
        align="right"
        format="yyyy-MM-dd HH:mm"
        unlink-panels
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="datePickerOptions"
      >
      </el-date-picker>

      <el-form class="form-modal">
        <h3 class="black-text mb-0 mt-0">Select Queue</h3>
        <dads-select
          v-model="selectedQueue"
          value-key="id"
          filterable
          style="margin-top: 0"
          placholder="Select Queue"
          @change="extOptions = []"
        >
          <template slot="prefix"> Queue </template>
          <el-option
            v-for="item in queueOptions"
            :key="item.id"
            :value="item"
            :label="item.name"
          />
        </dads-select>

        <h3 class="black-text mb-10 mt-0">Select Distribution</h3>
        <el-radio-group v-model="distribution">
          <el-radio-button type="default" label="daily">Daily</el-radio-button>
          <el-radio-button label="monthly">Monthly</el-radio-button>
          <el-radio-button label="hourly">Hourly</el-radio-button>
        </el-radio-group>

        <h3 class="black-text mb-0">Filter By</h3>
        <el-select
          v-model="primaryFilter"
          placeholder="Select Filter"
          clearable
          style="margin-top: 0"
        >
          <template slot="prefix"> Filter By </template>
          <el-option value="user" label="User" />
          <el-option value="tag" label="Tag" />
        </el-select>

        <dads-select
          v-if="primaryFilter === 'user'"
          v-model="extNumber"
          placeholder="Select A User"
          remote
          filterable
          clearable
          :remote-method="searchAgents"
        >
          <el-option
            v-for="(item, index) in extOptions"
            :key="index"
            :label="
              item.membername.replace(/_/g, ' ') +
              '- ' +
              item.memberdevice.split('-')[0]
            "
            :value="item.membername + '$' + item.memberdevice.split('-')[0]"
          />
          <template slot="prefix"> Filter By User </template>
        </dads-select>
        <el-input
            v-if="primaryFilter === 'tag'"
            placeholder="Enter Call Tag"
            v-model="tag"
          />
          <template slot="prefix"> Call Tag </template>

        <h3 class="black-text mb-0 mt-0">Select A Secondary Metric</h3>
        <el-select
          v-model="secondaryGroup"
          placeholder="Select Secondary Metric"
          clearable
          style="margin-top: 0"
        >
          <template slot="prefix"> Select Secondary Metric </template>
          <el-option value="abandonRate" label="Abandon Rate" />
          <el-option value="queue" label="Another Queue" />
          <el-option value="serviceLevel" label="Answered Under 30" />
          <el-option value="outboundCalls" label="Outbound Complete" />
          <el-option value="exits" label="Queue Exits" />
          <el-option value="durations" label="Talk Time / Wait Time" />
        </el-select>

        <div v-if="secondaryGroup === 'queue'">
          <h3 class="black-text mb-0 mt-0">Select A Secondary Queue</h3>
          <dads-select
            v-model="secondaryQueue"
            value-key="id"
            placeholder="Select Secondary Queue"
            clearable
            filterable
            style="margin-top: 0"
          >
            <template slot="prefix"> Secondary Queue </template>
            <el-option
              v-for="item in queueOptions"
              :key="item.id"
              :value="item"
              :label="item.name"
            />
          </dads-select>
        </div>

        <el-button class="mt-20" @click="doAdvanced"> Update </el-button>
      </el-form>
    </el-dialog>
    <div
      class="table-box page-header card-base card-shadow--medium call-history-plot-view mb-30"
    >
      <div v-if="!noQueues" class="flex">
        <div class="flex align-center">
          <!--          <h2 class="mt-0 mb-0 mr-5">
            <v-svg sprite="queue" class="voxo-red"></v-svg>
          </h2>-->
          <dads-select
            v-model="selectedQueue"
            value-key="id"
            filterable
            style="margin-top: 0"
            class="queue-quick-drop"
            placholder="Select Queue"
            @change="queueQuickLoad"
          >
            <el-option
              v-for="item in queueOptions"
              :key="item.id"
              :value="item"
              :label="item.name"
            />
          </dads-select>
        </div>

        <el-radio-group
          v-model="presetSelection"
          @change="doPreset"
          class="ml-10 hidden-xs-only"
        >
          <el-radio-button type="default" label="last10"
            >Last 10 Days</el-radio-button
          >
          <el-radio-button label="lastMonth">Last 30 Days</el-radio-button>
        </el-radio-group>

        <el-tooltip placement="top">
          <template slot="content">
            {{ selectedDateRange }}
            <br />
            User:
            {{
              extNumber
                ? extNumber.length
                  ? extNumber.replace(/_/g, " ").replace(/\$/g, " - ")
                  : "All"
                : "All"
            }}
            <br />
            Secondary:
            {{
              secondaryGroup
                ? secondaryGroup.length
                  ? getGroupName(secondaryGroup)
                  : "None"
                : "None"
            }}
          </template>
          <el-button
            @click="modalVisible = true"
            style="margin-left: auto; height: 40px"
          >
            Filter
          </el-button>
        </el-tooltip>
        <el-button
          @click="resetPlot(false)"
          v-if="advancedActive"
          style="background-color: #f25a6b; color: #fff; height: 40px"
        >
          Reset
        </el-button>
      </div>
      <div v-else class="flex">
        <h2 class="mt-0">
          <v-svg sprite="queue" class="voxo-red"></v-svg>
          Selected Account Has No Queues
        </h2>
      </div>
      <div
        id="activity-plot"
        style="height: 385px; width: 100%"
        class="mt-10"
        v-loading="plotLoading"
      ></div>
    </div>

    <div v-loading="plotLoading" class="mt-20">
      <el-row :gutter="30" v-if="!noQueues">
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate mt-0">
                    <v-svg
                      width="18"
                      height="18"
                      class="voxo-green"
                      sprite="call-inbound"
                    />
                    <span class="pl-10">COMPLETED</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      size="mini"
                      v-model="radioComplete"
                      @change="calcComplete"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="Avg"></el-radio-button>
                      <el-radio-button label="%"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                  {{ displayComplete }}
                </h1>
                <div class="stats-sub">
                  <div class="sub-stat-group"></div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ completeMaxValue }}
                    </div>
                    <div class="sub-stat-title text-right">
                      MAX - {{ completeMaxDate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate">
                    <v-svg class="voxo-red" sprite="call-inbound" />
                    <span class="pl-10">ABANDONED</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      v-model="radioAbandoned"
                      size="mini"
                      @change="calcAbandoned"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="Avg"></el-radio-button>
                      <el-radio-button label="%"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1
                  v-if="extNumber ? (extNumber.length ? 'N/A' : true) : true"
                  class="m-0 text-truncate voxo-blue text-center stat-number"
                >
                  {{ displayAbandoned }}
                </h1>
                <div class="stats-sub">
                  <div class="sub-stat-group"></div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ avgAbandonWaitTime }}s Wait
                    </div>
                    <div class="sub-stat-title text-right">PER CALL</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate">
                    <v-svg
                      width="18"
                      height="18"
                      class="voxo-dark-red"
                      sprite="call-block"
                    />
                    <span class="pl-10">REFUSED</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      v-model="radioRefused"
                      size="mini"
                      @change="calcRefused"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="Avg"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                  {{ displayRefused }}
                </h1>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="30" v-if="!noQueues">
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate">
                    <v-svg
                      width="18"
                      height="18"
                      class="voxo-aqua"
                      sprite="clock"
                    />
                    <span class="pl-10">TALK TIME</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      v-model="radioTalkTime"
                      size="mini"
                      @change="calcTalkTime"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="Avg"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                  {{ convertTime(displayTalkTime)
                  }}{{ radioTalkTime === "Avg" ? ` / ${unitsMap()}` : "" }}
                </h1>
                <div class="stats-sub" v-if="radioTalkTime === 'Avg'">
                  <div class="sub-stat-group"></div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ convertTime(perCallTalkTime) }}
                    </div>
                    <div class="sub-stat-title">PER CALL</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate">
                    <v-svg class="voxo-dark-red" sprite="clock" />
                    <span class="pl-10">WAIT TIME</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      v-model="radioWaitTime"
                      size="mini"
                      @change="calcWaitTime"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="Avg"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                  {{ convertTime(displayWaitTime)
                  }}{{ radioWaitTime === "Avg" ? ` / ${unitsMap()}` : "" }}
                </h1>
                <div class="stats-sub" v-if="radioWaitTime === 'Total'">
                  <div class="sub-stat-group">
                    <div class="sub-stat-number">
                      {{ convertTime(shortestWait) }}
                    </div>
                    <div class="sub-stat-title">SHORTEST</div>
                  </div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ convertTime(longestWait) }}
                    </div>
                    <div class="sub-stat-title text-right">LONGEST</div>
                  </div>
                </div>
                <div class="stats-sub" v-else>
                  <div class="sub-stat-group"></div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ convertTime(perCallWaitTime) }}
                    </div>
                    <div class="sub-stat-title text-right">PER CALL</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate">
                    <v-svg
                      width="18"
                      height="18"
                      class="voxo-blue"
                      sprite="call-forward"
                    />
                    <span class="pl-10">TRANSFERS</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      v-model="radioTransfers"
                      size="mini"
                      @change="calcTransfers"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="Avg"></el-radio-button>
                      <el-radio-button label="%"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                  {{ displayTransfers }}
                </h1>
                <div class="stats-sub">
                  <div class="sub-stat-group">
                    <div class="sub-stat-number">
                      {{ displayTotalATX }}
                    </div>
                    <div class="sub-stat-title">ATTENDED</div>
                  </div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ displayBlindX }}
                    </div>
                    <div class="sub-stat-title text-right">BLIND</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col
          v-if="primaryFilter != 'user'"
          :xs="24"
          :sm="24"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate">
                    <v-svg sprite="call-inbound" class="voxo-aqua"></v-svg>
                    <span class="pl-10">TOTAL INBOUND</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      v-model="radioUnique"
                      size="mini"
                      @change="calcUnique"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="%"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                  {{ totalInbound }}
                </h1>
                <div class="stats-sub">
                  <div class="sub-stat-group"></div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ displayUnique }}
                    </div>
                    <div class="sub-stat-title text-right">UNIQUE</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col
          v-if="primaryFilter != 'user'"
          :xs="24"
          :sm="24"
          :md="12"
          :lg="8"
          :xl="8"
        >
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate">
                    <v-svg sprite="arrow-outbound" class="voxo-pink"></v-svg>
                    <span class="pl-10">EXITS</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      v-model="radioExits"
                      size="mini"
                      @change="calcExits"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="Avg"></el-radio-button>
                      <el-radio-button label="%"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                  {{ displayTotalExits }}
                </h1>
                <div class="stats-sub">
                  <div class="sub-stat-group">
                    <div class="sub-stat-number">
                      {{ displayTotalExitTimeout }}
                    </div>
                    <div class="sub-stat-title">Timeout</div>
                  </div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ displayTotalExitKey }}
                    </div>
                    <div class="sub-stat-title text-right">Key</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <div class="card-base card-shadow--medium mb-30 widget small-widget">
            <div class="widget-header ph-20">
              <div class="stats-flex-body fadeInLeft">
                <div class="stat-header-flex flex widget-title">
                  <h3 class="stat-header text-truncate">
                    <v-svg
                      width="18"
                      height="18"
                      class="voxo-green"
                      sprite="call-outbound"
                    />
                    <span class="pl-10">CALLBACKS</span>
                  </h3>
                  <div
                    class="stat-switcher flex align-center"
                    style="margin-left: auto"
                  >
                    <el-radio-group
                      v-model="radioCallbacks"
                      size="mini"
                      @change="calcCallbacks"
                    >
                      <el-radio-button label="Total"></el-radio-button>
                      <el-radio-button label="%"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <h1 class="m-0 text-truncate voxo-blue text-center stat-number">
                  {{ displayCallbacks }}
                </h1>
                <div class="stats-sub">
                  <div class="sub-stat-group">
                    <div class="sub-stat-number">
                      {{ displaySuccessful }}
                    </div>
                    <div class="sub-stat-title">SUCCESSFUL</div>
                  </div>
                  <div class="sub-stat-group">
                    <div class="sub-stat-number text-right">
                      {{ displayFailed }}
                    </div>
                    <div class="sub-stat-title text-right">FAILED</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div
      v-if="!noQueues"
      class="table-box page-header card-base card-shadow--medium call-history-plot-view"
    >
      <heatmap-plot
        ref="heatMap"
        v-observe-visibility="heatmapVisibility"
        direction="queue"
        :metaData="{
          service: 'account-statistics',
          queryType: 'queueActivity',
          tenantId: selectedTenant.id,
          tenantCode: selectedTenant.tenantCode,
          queueId: selectedQueue ? selectedQueue.id : null,
          extNumber: extNumber,
          dispositions: ['Complete', 'Abandoned', 'Refused'],
        }"
      />
    </div>
  </div>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import moment from "moment-timezone";
import { mapActions } from "vuex";
import uniqBy from "lodash/uniqBy";
import echarts from "echarts";
import DadsSelect from "@/components/select";
import HeatmapPlot from "@/components/heatmap-plot.vue";

export default {
  name: "QueueTrendPlot",
  props: {
    maxTicks: { default: 9 },
    queueOptions: { required: true },
    colors: {
      default: () => ["#33aaee", "#35be8b", "#f25a6b", "#c485db"],
    },
    colorsSecondary: {
      default: () => ["#f79ca6", "#4cc3d2", "#ff8f02", "#0F85FF"],
    },
  },
  components: { DadsSelect, HeatmapPlot },
  data() {
    return {
      primaryData: null,
      secondaryData: null,
      selectedQueue: null,
      queueName: null,
      // queueOptions: [],
      dateStart: null,
      dateEnd: null,
      distribution: "daily",
      primaryFilter: null,
      extNumber: null,
      extOptions: [],
      secondaryQueue: null,
      secondaryGroup: null,
      secondaryOptions: [],
      secondaryOptionsList: [],
      resized: false,
      advancedActive: false,
      modalVisible: false,
      presetSelection: "last10",
      xInterval: 0,
      primaryLegend: [],
      plotLoading: false,
      noQueues: false,
      totalInbound: 0,
      totalComplete: 0,
      displayComplete: 0,
      totalAbandoned: 0,
      avgAbandonWaitTime: 0,
      displayAbandoned: 0,
      totalRefused: 0,
      displayRefused: 0,
      totalWaitTime: 0,
      displayWaitTime: 0,
      perCallWaitTime: 0,
      longestWait: null,
      shortestWait: null,
      totalTalkTime: 0,
      displayTalkTime: 0,
      totalTransfers: 0,
      displayTransfers: 0,
      radioCallbacks: "Total",
      completeCallbacks: 0,
      displayCallbacks: 0,
      displaySuccessful: 0,
      displayFailed: 0,
      successfulCallbacks: 0,
      failedCallbacks: 0,
      totalATX: 0,
      displayTotalATX: 0,
      totalBlindX: 0,
      displayBlindX: 0,
      perCallTalkTime: 0,
      completeMaxValue: 0,
      completeMaxDate: "",
      radioComplete: "Total",
      radioAbandoned: "Total",
      radioRefused: "Total",
      radioWaitTime: "Total",
      radioTalkTime: "Total",
      radioTransfers: "Total",
      radioExits: "Total",
      weightFactor: 1,
      totalUnique: 0,
      displayUnique: 0,
      radioUnique: "Total",
      exitKeyCount: 0,
      exitTimeoutCount: 0,
      totalExits: 0,
      displayTotalExits: 0,
      displayTotalExitKey: 0,
      displayTotalExitTimeout: 0,
      historyDateRange: [moment(), moment()],
      tag: "",
      datePickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(1, "week").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(1, "month").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(3, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 6 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(6, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last year",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment().subtract(12, "months").format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    colorTheme() {
      return this.$store.state.layout.theme;
    },
    selectedDateRange() {
      if (this.dateEnd && this.dateStart) {
        const dateStart = moment(this.dateStart).format("M/D/YY HH:mm");
        const dateEnd = moment(this.dateEnd).format("M/D/YY HH:mm");
        return `${dateStart} - ${dateEnd}`;
      }
    },
  },
  watch: {
    queueOptions() {
      this.resetPlot(true);
    },
  },
  methods: {
    ...mapActions("queues", { findQueues: "find" }),
    async initData() {
      if (this.queueOptions.length) {
        this.noQueues = false;
        this.selectedQueue = this.queueOptions[0];
        this.doPreset("last10");
        //this event is just to give this component load time before trigger builds on other tabs.
        setTimeout(() => {
          this.$emit("waveReady");
        }, 1500);
      } else {
        if (this.chart) {
          this.chart.dispose();
        }
        this.noQueues = true;
      }
    },

    heatmapVisibility(isVisible) {
      if (isVisible) {
        setTimeout(() => {
          this.$refs.heatMap.buildCalendarHeatmap();
        }, 500);
      }
    },

    doPreset(val) {
      if (val === "last10") {
        this.dateEnd = moment(moment().format("YYYY-MM-DD"))
          .add(1, "day")
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.dateStart = moment().subtract(9, "days").format("YYYY-MM-DD");
        this.presetSelection = "last10";
        this.updateDateRangePicker();
        this.queryStats();
      }

      if (val === "lastMonth") {
        this.dateEnd = moment(moment().format("YYYY-MM-DD"))
          .add(1, "day")
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.dateStart = moment().subtract(30, "days").format("YYYY-MM-DD");
        this.presetSelection = "lastMonth";
        this.updateDateRangePicker();
        this.queryStats();
      }
    },
    doAdvanced() {
      this.dateStart = moment(this.historyDateRange[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.dateEnd = moment(this.historyDateRange[1]).format(
        "YYYY-MM-DD HH:mm"
      );

      //if hourly distribution make sure it passes 30 day limit
      let allowed = 1;
      if (this.distribution === "hourly") {
        allowed =
          moment(this.dateEnd).diff(
            moment(this.dateStart).add(1, "day"),
            "days"
          ) <= 30;
      }

      if (allowed) {
        this.queryStats();
        this.handleCloseModal();
        this.advancedActive = true;
      } else {
        this.$notify({
          type: "error",
          message: "Max of 30 days exceeded for hourly distribution",
          title: "Limit Exceeded",
        });
      }
    },
    queueQuickLoad() {
      this.dateStart = moment(this.historyDateRange[0]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.dateEnd = moment(this.historyDateRange[1]).format(
        "YYYY-MM-DD HH:mm"
      );
      this.queryStats();
    },
    resetPlot(tenantChanged) {
      this.advancedActive = false;
      this.primaryFilter = "";
      this.secondaryGroup = "";
      this.extNumber = "";
      this.secondaryQueue = null;
      this.distribution = "daily";
      this.secondaryOptions = [];
      this.secondaryOptionsList = [];
      this.extOptions = [];
      this.tag = "";
      this.advancedActive = false;
      if (tenantChanged) {
        this.queueName = null;
        this.initData();
      } else {
        this.doPreset("last10");
      }
    },
    updateDateRangePicker() {
      this.historyDateRange = [moment(this.dateStart), moment(this.dateEnd)];
    },
    handleCloseModal() {
      this.modalVisible = false;
    },
    convertTime(time) {
      if (time !== null) {
        const hours = Math.floor(time / 3600);
        const remainderSeconds = time % 3600;
        const minutes = Math.floor(remainderSeconds / 60);
        const seconds = Math.round(remainderSeconds % 60);

        if (hours > 0) {
          return hours + "hr " + minutes + "m";
        }
        if (minutes > 0) {
          return minutes + "m";
        }
        if (seconds > 0) {
          return seconds + "s";
        }
        return "0";
      }

      return "N/A";
    },
    async searchAgents(query) {
      if (query.length) {
        const searchTerm = (query + "")
          .replace(/[\\"']/g, "\\$&")
          .replace(/\u0000/g, "\\0");

        const allowedMembers = await feathersClient
          .service("queuemembers-allowed")
          .find({
            query: {
              queueName: this.selectedQueue.id,
              $or: [
                { membername: { $like: `%${searchTerm}%` } },
                { memberdevice: { $like: `%${searchTerm}%` } },
              ],
            },
          });

        const members = await feathersClient.service("queuemembers").find({
          query: {
            queueName: this.selectedQueue.id,
            $or: [
              { membername: { $like: `%${searchTerm}%` } },
              { memberdevice: { $like: `%${searchTerm}%` } },
            ],
          },
        });

        const allMembers = [...allowedMembers, ...members];
        this.extOptions = uniqBy(allMembers, "membername");
      }
    },
    buildX() {
      const dateKeys = Object.keys(this.primaryData);
      this.weightFactor = dateKeys.length;

      this.xInterval = 0;

      if (dateKeys.length > this.maxTicks) {
        this.xInterval = Math.ceil(dateKeys.length / this.maxTicks);
      }

      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";

      return {
        data:
          this.distribution === "hourly"
            ? dateKeys.map((item) => item.split("_")[1])
            : dateKeys,
        boundaryGap: dateKeys.length <= 10,
        axisLabel: {
          interval: this.xInterval,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: axisColor,
          },
        },
        axisTick: {
          interval: this.xInterval,
        },
      };
    },
    buildY1() {
      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";
      return {
        name: "Calls",
        position: "left",
        splitLine: { show: false },
        axisLine: {
          lineStyle: {
            color: axisColor,
          },
        },
      };
    },
    buildY2() {
      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";

      //this will be time or calls or percent based on secondary group.
      const unitsKey = {
        outboundCalls: "Outbound",
        durations: "Duration",
        serviceLevel: "%",
        abandonRate: "%",
      };

      const axisName = unitsKey[this.secondaryGroup];

      return {
        name: axisName,
        position: "right",
        splitLine: { show: false },
        axisLine: {
          lineStyle: {
            color: axisColor,
          },
        },
      };
    },
    buildPrimary(xAxis) {
      this.primaryLegend = [];
      this.plotGroups = ["Complete", "Abandoned", "Refused"];
      this.completeMaxDate = "";
      this.completeMaxValue = 0;

      if (this.primaryData) {
        const callData = { ...this.primaryData };

        let dataGroups = {};
        for (let i = 0; i < this.plotGroups.length; i++) {
          dataGroups[this.plotGroups[i]] = [];
        }

        for (let day in callData) {
          if (callData.hasOwnProperty(day)) {
            dataGroups["Complete"].push(callData[day].inboundComplete);
            dataGroups["Abandoned"].push(callData[day].totalAbandoned);
            dataGroups["Refused"].push(callData[day].totalRefused);

            if (callData[day].inboundComplete > this.completeMaxValue) {
              this.completeMaxDate = day;
              this.completeMaxValue = +callData[day].inboundComplete;
            }
          }
        }

        let series = [];
        let count = 0;
        for (let group in dataGroups) {
          if (dataGroups.hasOwnProperty(group)) {
            series.push({
              name: `${group}`,
              type: xAxis.length > 13 ? "line" : "bar",
              symbol: "circle",
              smooth: true,
              showSymbol: true,
              yAxisIndex: 0,
              symbolRepeat: true,
              symbolSize: 3,
              symbolMargin: 1,
              barMaxWidth: 10,
              z: -10,
              lineStyle: {
                color: this.colors[count],
              },
              itemStyle: {
                color: this.colors[count],
                borderColor: this.colors[count],
                borderWidth: 3,
              },
              data: dataGroups[group],
            });
            this.primaryLegend.push({ name: `${group}` });
            count++;
          }
        }
        return series;
      }

      return [];
    },
    buildSecondary(xAxis) {
      const callData = { ...this.secondaryData };

      //need to initialize the data groups here.
      let dataGroups = {};
      const dataGroupKeys = this.getDataGroupKeys();
      for (let i = 0; i < dataGroupKeys.length; i++) {
        dataGroups[dataGroupKeys[i]] = [];
      }

      for (let day in callData) {
        if (callData.hasOwnProperty(day)) {
          //outbound Calls
          if (this.secondaryGroup === "outboundCalls") {
            dataGroups["outboundTotal"].push(+callData[day].outboundTotal);
            dataGroups["outboundDuration"].push(
              +(+callData[day].outboundDuration / 60).toFixed(2)
            );
          }

          if (this.secondaryGroup === "durations") {
            dataGroups["totalTalkTime"].push(
              +(+callData[day].totalTalkTime / 60).toFixed(2)
            );
            dataGroups["totalWaitTime"].push(
              +(+callData[day].totalWaitTime / 60).toFixed(2)
            );
          }

          if (this.secondaryGroup === "serviceLevel") {
            dataGroups["percentSLA"].push(+callData[day].percentSLA);
          }

          if (this.secondaryGroup === "abandonRate") {
            dataGroups["abandonRate"].push(+callData[day].abandonRate);
          }

          if (this.secondaryGroup == "queue") {
            dataGroups["inboundComplete"].push(callData[day].inboundComplete);
            dataGroups["totalAbandoned"].push(callData[day].totalAbandoned);
            dataGroups["totalRefused"].push(callData[day].totalRefused);
          }

          if (this.secondaryGroup === "exits") {
            dataGroups["exitsWithKey"].push(callData[day].exitsWithKey);
            dataGroups["exitsWithTimeout"].push(callData[day].exitsWithTimeout);
          }
        }
      }

      //loop over the data groups and build out the series
      let series = [];
      let count = 0;
      for (let group in dataGroups) {
        if (dataGroups.hasOwnProperty(group)) {
          series.push({
            name: this.getGroupName(group),
            type: xAxis.length === 1 ? "bar" : "line",
            symbol: "circle",
            smooth: true,
            showSymbol: true,
            yAxisIndex: 1,
            symbolRepeat: true,
            symbolSize: 3,
            symbolMargin: 1,
            barMaxWidth: 10,
            z: -10,
            lineStyle: {
              color: this.colorsSecondary[count],
            },
            itemStyle: {
              color: this.colorsSecondary[count],
              borderColor: this.colorsSecondary[count],
              borderWidth: 3,
            },
            data: dataGroups[group],
          });
          this.primaryLegend.push({ name: this.getGroupName(group) });
          count++;
        }
      }
      return series;
    },
    buildChart() {
      if (this.chart) {
        this.chart.dispose();
      }

      this.chart = echarts.init(this.chartElement);

      const xAxis = this.buildX();
      const y1 = this.buildY1();

      const data1 = this.buildPrimary(xAxis.data);

      let y2 = null;
      let data2 = null;

      if (this.secondaryData) {
        y2 = this.buildY2();
        data2 = this.buildSecondary(xAxis.data);
      }

      const seriesData = data2 ? [...data1, ...data2] : data1;
      const yAxis = y2 ? [y1, y2] : [y1];

      const axisColor =
        this.colorTheme === "theme-dark"
          ? "rgba(255,255,255,0.5)"
          : "rgba(0,0,0, 0.5)";

      this.chart.setOption({
        grid: {},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        xAxis,
        yAxis,
        series: seriesData,
        legend: {
          show: true,
          type: "scroll",
          orient: "horizontal",
          icon: "rectangle",
          itemWidth: 15,
          itemHeight: 3,
          data: this.primaryLegend,
          textStyle: {
            color: axisColor,
          },
        },
      });
    },
    queryStats() {
      this.plotLoading = true;
      feathersClient
        .service("account-statistics")
        .create({
          type: "queueActivity",
          tenantId: this.selectedTenant.id,
          tenantCode: this.selectedTenant.tenantCode,
          queueId: this.selectedQueue.id,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          distribution: this.distribution,
          primaryFilter: this.primaryFilter,
          extNumber: this.extNumber,
          secondaryQueue: this.secondaryQueue ? this.secondaryQueue.id : null,
          secondaryGroup: this.secondaryGroup,
          secondaryOptions: this.secondaryOptions,
          timezone: this.user.timezone,
          tag: this.tag,
        })
        .then((res) => {
          const {
            totalComplete,
            totalAbandoned,
            totalRefused,
            totalTalkTime,
            totalWaitTime,
            totalTransfers,
            totalInbound,
            shortestWait,
            longestWait,
            totalATX,
            totalBlindX,
            avgAbandonWaitTime,
            exitTimeoutCount,
            exitKeyCount,
            totalUnique,
            completeCallbacks,
            successfulCallbacks,
            failedCallbacks
          } = res.primary.data;
          this.queueName = this.selectedQueue.name;
          this.primaryData = res.primary.data.distributionData;
          this.secondaryData = res.secondary.data;
          this.totalComplete = totalComplete;
          this.totalAbandoned = totalAbandoned;
          this.avgAbandonWaitTime = avgAbandonWaitTime;
          this.totalRefused = totalRefused;
          this.totalTalkTime = totalTalkTime;
          this.totalWaitTime = totalWaitTime;
          this.totalTransfers = totalTransfers;
          this.totalATX = totalATX;
          this.totalBlindX = totalBlindX;
          this.totalInbound = totalInbound;
          this.shortestWait = shortestWait;
          this.longestWait = longestWait;
          this.perCallTalkTime = totalTalkTime / totalComplete;
          this.totalUnique = totalUnique;
          this.completeCallbacks = completeCallbacks;
          this.successfulCallbacks = successfulCallbacks;
          this.failedCallbacks = failedCallbacks;
          this.exitKeyCount = exitKeyCount;
          this.exitTimeoutCount = exitTimeoutCount;
          this.totalExits = exitKeyCount + exitTimeoutCount;
          this.buildChart();
          this.buildDisplayStats();
          this.plotLoading = false;
        })
        .catch(() => {
          console.log("Could Not Process Stats Request");
          this.plotLoading = false;
        });
    },
    buildDisplayStats() {
      this.calcComplete(this.radioComplete);
      this.calcAbandoned(this.radioAbandoned);
      this.calcRefused(this.radioRefused);
      this.calcTalkTime(this.radioTalkTime);
      this.calcWaitTime(this.radioWaitTime);
      this.calcTransfers(this.radioTransfers);
      this.calcUnique(this.radioUnique);
      this.calcExits(this.radioExits);
      this.calcCallbacks(this.radioCallbacks);
    },
    calcExits(val) {
      const valueMap = {
        Total: this.totalExits,
        Avg: `${(this.totalExits / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalInbound
          ? `${((this.totalExits / this.totalInbound) * 100).toFixed(1)} %`
          : "N/A",
      };
      const valueMapKey = {
        Total: this.exitKeyCount,
        Avg: `${(this.exitKeyCount / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalInbound
          ? `${((this.exitKeyCount / this.totalInbound) * 100).toFixed(1)} %`
          : "N/A",
      };
      const valueMapTimeout = {
        Total: this.exitTimeoutCount,
        Avg: `${(this.exitTimeoutCount / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalInbound
          ? `${((this.exitTimeoutCount / this.totalInbound) * 100).toFixed(
              1
            )} %`
          : "N/A",
      };
      this.displayTotalExits = valueMap[val];
      this.displayTotalExitKey = valueMapKey[val];
      this.displayTotalExitTimeout = valueMapTimeout[val];
    },
    calcUnique(val) {
      const valueMap = {
        Total: this.totalUnique,
        "%": this.totalInbound
          ? `${((this.totalUnique / this.totalInbound) * 100).toFixed(1)} %`
          : "N/A",
      };
      this.displayUnique = valueMap[val];
    },
    calcCallbacks(val) {
      const valueMap = {
        Total: this.completeCallbacks,
        "%": this.completeCallbacks
      };

      const mapSuccessful = {
        Total: this.successfulCallbacks,
        "%": this.successfulCallbacks
          ? `${((this.successfulCallbacks / this.completeCallbacks) * 100).toFixed(1)} %`
          : "N/A"
      };

      const mapFailed = {
        Total: this.failedCallbacks,
        "%": this.failedCallbacks
          ? `${((this.failedCallbacks / this.completeCallbacks) * 100).toFixed(1)} %`
          : "N/A"
      };
      this.displayCallbacks = valueMap[val];
      this.displaySuccessful = mapSuccessful[val];
      this.displayFailed = mapFailed[val];
    },
    calcComplete(val) {
      const valueMap = {
        Total: this.totalComplete,
        Avg: `${(this.totalComplete / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalInbound
          ? `${((this.totalComplete / this.totalInbound) * 100).toFixed(1)} %`
          : "N/A",
      };
      this.displayComplete = valueMap[val];
    },
    calcAbandoned(val) {
      const valueMap = {
        Total: this.totalAbandoned,
        Avg: `${(this.totalAbandoned / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalInbound
          ? `${((this.totalAbandoned / this.totalInbound) * 100).toFixed(1)}%`
          : "N/A",
      };
      this.displayAbandoned = valueMap[val];
    },
    calcRefused(val) {
      const valueMap = {
        Total: this.totalRefused,
        Avg: `${(this.totalRefused / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
      };
      this.displayRefused = valueMap[val];
    },
    calcTalkTime(val) {
      const valueMap = {
        Total: this.totalTalkTime,
        Avg: this.totalTalkTime / this.weightFactor,
      };
      this.displayTalkTime = valueMap[val];
    },
    calcWaitTime(val) {
      const valueMap = {
        Total: this.totalWaitTime,
        Avg: this.totalWaitTime / this.weightFactor,
      };
      this.perCallWaitTime = this.totalComplete
        ? this.totalWaitTime / this.totalComplete
        : 0;
      this.displayWaitTime = valueMap[val];
    },
    calcTransfers(val) {
      const valueMap = {
        Total: this.totalTransfers,
        Avg: `${(this.totalTransfers / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalInbound
          ? `${((this.totalTransfers / this.totalInbound) * 100).toFixed(1)} %`
          : "N/A",
      };

      const valueMapATX = {
        Total: this.totalATX,
        Avg: `${(this.totalATX / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalInbound
          ? `${((this.totalATX / this.totalInbound) * 100).toFixed(1)} %`
          : "N/A",
      };

      const valueMapBlind = {
        Total: this.totalBlindX,
        Avg: `${(this.totalBlindX / this.weightFactor).toFixed(
          2
        )} / ${this.unitsMap()}`,
        "%": this.totalInbound
          ? `${((this.totalBlindX / this.totalInbound) * 100).toFixed(1)} %`
          : "N/A",
      };

      this.displayTransfers = valueMap[val];
      this.displayTotalATX = valueMapATX[val];
      this.displayBlindX = valueMapBlind[val];
    },
    unitsMap() {
      const valueMap = {
        hourly: "hr",
        daily: "day",
        monthly: "mo",
      };
      return valueMap[this.distribution];
    },
    getDataGroupKeys() {
      const group = this.secondaryGroup;
      switch (group) {
        case "outboundCalls":
          return ["outboundTotal", "outboundDuration"];
        case "durations":
          return ["totalTalkTime", "totalWaitTime"];
        case "serviceLevel":
          return ["percentSLA"];
        case "abandonRate":
          return ["abandonRate"];
        case "queue":
          return ["inboundComplete", "totalAbandoned", "totalRefused"];
        case "exits":
          return ["exitsWithKey", "exitsWithTimeout"];
        default:
          return [];
      }
    },
    getGroupName(val) {
      const groupMap = {
        outboundCalls: "Outbound Calls",
        outboundTotal: "Outbound Calls",
        outboundDuration: "Outbound Duration (mins)",
        durations: "Durations (mins)",
        totalTalkTime: "Total Talk Time",
        totalWaitTime: "Total Wait Time",
        serviceLevel: "Answered Under 30",
        percentSLA: "Answered Under 30",
        abandonRate: "Abandon Rate",
        inboundComplete: `Complete (${
          this.secondaryQueue ? this.secondaryQueue.name : "2"
        })`,
        totalAbandoned: `Abandoned (${
          this.secondaryQueue ? this.secondaryQueue.name : "2"
        })`,
        totalRefused: `Refused (${
          this.secondaryQueue ? this.secondaryQueue.name : "2"
        })`,
        queue: this.secondaryQueue ? this.secondaryQueue.name : "Another Queue",
        exitsWithKey: "Exits Key",
        exitsWithTimeout: "Exits Timeout",
        exits: "Queue Exits",
      };
      return groupMap[val];
    },
  },
  mounted() {
    this.chartElement = document.getElementById("activity-plot");
  },
};
</script>

<style lang="scss" scoped>
.stat-number {
  font-size: 2.25em;
  margin-top: 10px;
}

.stat-header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  margin: 0;
  min-height: 32px;
}

.stats-sub {
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  width: 100%;
  margin-top: auto;
  height: 45px;
}

.stats-flex-body {
  height: 200px;
  display: flex;
  flex-direction: column;
}

.stat-header-flex {
  padding: 20px 0 12px 0;
}

.sub-stat-number {
  font: {
    weight: bold;
  }
}

.sub-stat-title {
  font-size: 0.85em;
}
</style>
